import script from "./PlantaQuadra.vue?vue&type=script&setup=true&lang=js"
export * from "./PlantaQuadra.vue?vue&type=script&setup=true&lang=js"

import "./PlantaQuadra.vue?vue&type=style&index=0&id=add2b0f2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-add2b0f2"]])

export default __exports__